import Accordion from "./Accordion";
import Button from "./Button";
import Card from "./Card";
import Tabs from "./Tabs";
import Typography from "./Typography";
// ----------------------------------------------------------------------
// eslint-disable-next-line import/no-default-export, @typescript-eslint/explicit-module-boundary-types
export default function ComponentsOverrides(theme) {
    return window.Object.assign(Card(theme), Button(theme), Typography(theme), Tabs(theme), Accordion(theme));
}
